import styled, { css, keyframes } from 'styled-components';
import { IButton } from './button.type';
import { theme } from '@theme';

const sizeStyles = {
  small: css`
    padding: 4px 12px;
    font-size: 0.875rem;
  `,
  medium: css`
    padding: 8px 16px;
    font-size: 1rem;
  `,
  large: css`
    padding: 11px 24px;
    font-size: 1.125rem;
  `,
};

const variantStyles = {
  primary: css`
    background-color: #C6A691;
    color: ${theme.palette.default};
    border: none;
  `,
  secondary: css`
    background-color: rgba(222, 215, 208, 1);
    color: rgba(109, 86, 63, 1);
    border: none;
  `,
  outlined: css`
    background: inherit;
    color: #C6A691;
    border: 1px solid #C6A691;
  `,
  text: css`
    background: none;
    color: #C6A691;
    border: none;
  `
};
const variantHoverStyles = {
  primary: css`
    background-color: #BD987F;
  `,
  secondary: css``,
  outlined: css`
    color: #BD987F;
    border: 1px solid #BD987F;
  `,
  text: css`
    color: #BD987F;
  `
};
const variantActiveStyles = {
  primary: css`
    background-color: #B2876B;
  `,
  secondary: css``,
  outlined: css`
    color: #B2876B;
    border: 1px solid #B2876B;
  `,
  text: css`
    color: #B2876B;
  `
};

export const ButtonWrapper = styled.button<IButton>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  border-radius: ${({ rounded }) => (rounded ? '999px' : '6px')};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: all .3s;

  ${({ size = 'medium' }) => sizeStyles[size]}
  ${({ variant = 'primary' }) => variantStyles[variant]}

  &:disabled {
    opacity: .3;
    cursor: not-allowed;
  }
  
  &:hover{
    ${({ variant = 'primary' }) => variantHoverStyles[variant]}
  }
  
  &:active{
    ${({ variant = 'primary' }) => variantActiveStyles[variant]}
  }
  
  &:focus{
    outline: none;
  }
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Loading = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-top: 2px solid #ffffff;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
